module.exports = __webpack_public_path__ + "img/arena_fest.cfd395fa.jpg";